import { nodeConfig } from '@/mixins';

const NAMESPACE = 'cookie-notice';
const DEFAULT_SELECTOR = '[data-js-cookie-notice]';
const DEFAULT_SETTINGS = {};

class CookieNotice {
	constructor(node, config) {
		this.node = node;
		this.config = config;
		this.acceptButton = this.node.querySelector('[data-js-cookie-notice-button="accept"]');
		this.rejectButton = this.node.querySelector('[data-js-cookie-notice-button="reject"]');
	}

	hideMessage() {
		this.node.classList.remove('cookie-notice--visible');
		this.node.setAttribute('inert', '');
	}

	showMessage() {
		this.node.classList.add('cookie-notice--visible');
		this.node.removeAttribute('inert');
	}

	onAcceptClick() {
		this.setConsent({
			necessary: true,
			analytics: true,
			preferences: true,
			marketing: true
		});

		this.hideMessage();
	}

	onRejectClick() {
		this.setConsent({
			necessary: false,
			analytics: false,
			preferences: false,
			marketing: false
		});

		this.hideMessage();
	}

	setConsent(consent) {
		if (!window.hasOwnProperty('gtag')) return;

		const consentMode = {
			ad_storage: consent.marketing ? 'granted' : 'denied',
			ad_user_data: consent.marketing ? 'granted' : 'denied',
			ad_personalization: consent.marketing ? 'granted' : 'denied',
			analytics_storage: consent.analytics ? 'granted' : 'denied',
			functionality_storage: consent.necessary ? 'granted' : 'denied',
			personalization_storage: consent.preferences ? 'granted' : 'denied',
			security_storage: consent.necessary ? 'granted' : 'denied'
		};

		gtag('consent', 'update', consentMode);

		localStorage.setItem('consentMode', JSON.stringify(consentMode));
	}

	bindUI() {
		this.acceptButton.addEventListener('click', () => {
			this.onAcceptClick();
		});

		this.rejectButton.addEventListener('click', () => {
			this.onRejectClick();
		});
	}

	init() {
		if (localStorage.getItem('consentMode') !== null) return;

		this.showMessage();
		this.bindUI();
	}
}

export default function factory(selector = DEFAULT_SELECTOR, settings = {}) {
	let listNode = document.querySelectorAll(selector);

	if (!listNode.length) return;

	return Array.from(listNode).map((node) => {
		let config = nodeConfig(node, NAMESPACE, settings, DEFAULT_SETTINGS);
		let module = new CookieNotice(node, config);

		module.init();

		return module;
	});
}
